import { loadStripe } from "@stripe/stripe-js";

export const getStripePromise = () => {
  const { REACT_APP_STRIPE_PUBLISHABLE_KEY } = process.env;
  const stripePromise = loadStripe(REACT_APP_STRIPE_PUBLISHABLE_KEY);
  return stripePromise;
};
